<template>
  <v-container fluid>
    <v-card outlined>
      <v-data-table :headers="headers" :items="items" :items-per-page="-1">
        <template v-slot:item.actions="{ item }">
          <v-row>
            <v-btn icon small class="mx-0" @click="onDetails(item)">
              <v-icon small color="cyan">mdi-file-find</v-icon>
            </v-btn>
          </v-row>
        </template>
      </v-data-table>
    </v-card>
    <increments-group-dialog
      v-model="selectedGroup"
      :show="showGroupDetails"
      @close="showGroupDetails = false"
      :department="department"
      :destination="destination"
      :templateItems="templateItems"
    />
  </v-container>
</template>

<script>
import IncrementsGroupDialog from "./IncrementsGroupDialog.vue";
import { ITINERARY_RECALCULATE_MUTATION } from "../../../../../constants/graphql";
export default {
  components: { IncrementsGroupDialog },
  name: "grouped-increments",

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    templateItems: {
      type: Array,
      default: () => [],
    },
    templateId: {
      type: String,
      default: () => "",
    },
    department: {
      type: String,
      default: () => "FIT",
    },
    destination: {
      type: String,
      default: () => "",
    },
  },

  data() {
    return {
      debug: false,
      headers: [
        {
          text: "Ref",
          value: "reference",
          name: "reference",
        },
        {
          text: "Min Pax",
          value: "minPax",
          name: "minPax",
        },
        {
          text: "Max Pax",
          value: "maxPax",
          name: "maxPax",
        },
        {
          text: "Actions",
          value: "actions",
          name: "actions",
        },
      ],
      showGroupDetails: false,
      selectedGroup: null,
    };
  },

  computed: {
    items() {
      return this.value
        ? [...new Set(this.value.map((i) => i.uid))].map((uid) => ({
            ...this.value.find((i) => i.uid == uid),
          }))
        : [];
    },
  },

  methods: {
    onDetails(item) {
      this.selectedGroup = {
        reference: item.reference,
        minPax: item.minPax,
        maxPax: item.maxPax,
        step: item.step,
        increments: [...this.value.filter((i) => i.uid == item.uid)],
      };
      this.showGroupDetails = true;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/templates/builder/increments/GroupedIncrements.vue